<template>
    <div class="report__item__wrap">
        <div>
            <div class="flex align-items-start">
                <div class="flex-2 mr--10">
                    <BaseCard class="mb--35" shadow>
                        <template #card-body>
                            <div class="report__item__header">
                                <p class="text--medium text--base">
                                    Number of invoices created per month
                                </p>
                            </div>
                            <bar-chart :data="transformedData.invoicesByMonth" />
                        </template>
                    </BaseCard>
        
                    <div class="mb--35">
                        <FormLabel title="Distribution by currency" label-type="title" class="mb--10" />
                        <PieChartReport field="invoice" :stats-data="transformedData.invoicesByCurrency" />
                    </div>
                </div>
                <div class="flex-1">
                    <div class="mb--25">
                        <FormLabel title="Status count " label-type="title" class="mb--5 text--capitalize" />
                        <StatusDistribution  
                            :status-data="statusData"
                            label="Status Count"
                            field="invoice"
                        />
                    </div>
        
                    <div>
                        <FormLabel title="Status percentage" label-type="title" class="mb--5 text--capitalize" />
                        <StatusPercentage  
                            :status-data="ratesData"
                            label="Percentage Status"
                        />
                    </div>
        
                    <Stats
                        title="Invoices Created on an Average"
                        :value="transformedData.avgInvoices"
                        class="mt--20"
                        :show-percentage="false"
                        :format-val="0"
                    />
    
                    <Stats
                        title="Average Paid out Invoice"
                        :value="transformedData.avgPaidInvoices"
                        class="mt--20"
                        :show-percentage="false"
                        :format-val="0"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { BaseCard } from "@/components/ui/index";
import { getMonthFromNum } from "@/utils/helpers";
import { invoiceFilterStatuses }from "@/utils/enums";

import StatusDistribution from "../stats/StatusDistribution.vue";
import StatusPercentage from "../stats/StatusPercentage.vue";
import PieChartReport from "../stats/PieChartReport.vue";
import Stats from "../stats/Stats.vue";
import FormLabel from "../ui/forms/FormLabel.vue";

export default {
    name: "InvoiceReports",

    components: {
        BaseCard,
        StatusDistribution,
        StatusPercentage,
        PieChartReport,
        Stats,
        FormLabel,
    },

    data() {
        return {
            invoiceFilterStatuses,
        };
    },

    computed: {
        reportDataProps() {
            return this.$store.getters["report/reportData"]?.invoices;
        },

        transformedData() {
            if (!this.reportDataProps) return {};
            
            const data = {};
            const keys = Object.keys(this.reportDataProps);

            if (!keys && keys.length) return {};

            for (let i = 0; i < keys.length; i++) {
                const item = keys[i];
                const list = this.reportDataProps[item]; 

                switch(item) {  
                case "invoicesByCurrency":
                    data.invoicesByCurrency = list.map(x => ([x._id, x.count])) || [];
                    break;
                case "invoicesByMonth":
                    data.invoicesByMonth = list.map(i => ([this.getMonthFromNum(i?._id), i?.count])) || [];
                    break;

                case "sumPaidInvoices":
                    data.sumPaidInvoices = list.length && list[0]?.count || 0;
                    break;

                case "invoicesByStatus":
                    data.invoicesByStatus = list.length && list || [];
                    break;

                case "totalNum":
                    data.totalNum = list.length && list[0]?.count || 0;
                    break;

                case "averageCreatedInvoice":
                    data.avgInvoices = list.length && list[0]?.avgInvoices || 0;
                    break;

                case "averageFullyPaidInvoice":
                    data.avgPaidInvoices = list.length && list[0]?.avgPaidInvoices || 0;
                    break;

                default:
                    break;
                }
            }

            return data;
        },

        // paidRate() {
        //     if (!this.transformedData?.sumPaidInvoices || !this.transformedData?.totalNum) return 0;

        //     const percentageValue = (this.transformedData?.sumPaidInvoices / this?.transformedData.totalNum) * 100;

        //     return percentageValue && typeof percentageValue === "number" && percentageValue.toFixed(2);
        // },

        ratesData() {
            const statusMap = new Map(this.transformedData.invoicesByStatus?.map(item => item && [item._id, item.count]));
            const totalNum = this.transformedData.totalNum;
            
            return invoiceFilterStatuses.map(item => {
                const count = statusMap.get(item) || 0;
                const percentageValue = totalNum > 0 ? ((count / totalNum) * 100).toFixed(0) : "0";
                
                return {
                    id: item,
                    percentageValue,
                };
            });
        },

        statusData() {
            const statusMap = new Map(this.transformedData.invoicesByStatus?.map(item => item && [item._id, item.count]));
            
            return invoiceFilterStatuses.map(item => {
                const count = statusMap.get(item) || 0;
                
                return {
                    id: item,
                    count,
                };
            });
        },
    },

    methods: {
        getMonthFromNum,
    },
};
</script>